import { useDeviceTypes } from 'hooks/useDeviceTypes/useDeviceTypes';
import { DeviceClass, DeviceTypeId } from 'shared/models';
import { ChangeEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LegacySelectField } from 'ui/shared/controls';

export type Props = {
    id: string;
    name?: string;
    deviceClass?: DeviceClass;
    value?: DeviceTypeId;
    onChange(e: ChangeEvent): void;
    initialSelection?: DeviceTypeId[];
};

export const DeviceTypeSelectField = ({ id, name, deviceClass, value, onChange, initialSelection }: Props) => {
    const { t } = useTranslation();
    const { deviceTypes, deviceTypeOrder } = useDeviceTypes({ deviceClass });
    const [ showAll, setShowAll ] = useState(!initialSelection);

    const handleShowAllClick = useCallback(() => {
        setShowAll(true);
    }, [ setShowAll ]);
    
    // Render a fake control until the device types have been loaded
    if (!Object.keys(deviceTypes)) {
        return (
            <LegacySelectField
                id={ id }
                input={ {
                    name,
                    value: '',
                    onChange: () => {},
                } }
                required={ true }
                disabled={ true }
                labelKey="DEVICES.EDIT_DIALOG.FIELD.DEVICE_TYPE"
            >
                <option value="">
                    { t('LOADING') }
                </option>
            </LegacySelectField>
        );
    }

    return (
        <LegacySelectField
            id={ id }
            input={ {
                name,
                value,
                onChange,
            } }
            onShowAllClick={ handleShowAllClick }
            required={ true }
            labelKey="DEVICES.EDIT_DIALOG.FIELD.DEVICE_TYPE"
        >
            <option key="none" value=""/>
            { deviceTypeOrder
                .filter(id => initialSelection?.includes(id))
                .map(id =>
                <option key={ id } value={ id }>
                    { deviceTypes[id].displayName }
                </option>
            ) }
            { showAll && (
                deviceTypeOrder
                    .filter(id => !initialSelection?.includes(id))
                    .map(id =>
                        <option key={ id } value={ id }>
                            { deviceTypes[id].displayName }
                        </option>
                    )
            )}
        </LegacySelectField>
    );
};
